import VehicleComparisonCard from "./VehicleComparisonCard";

export default VehicleComparisonCard;
